/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { Landmark } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';

const NS = '/bff/v1/j09-s05-financeiro-cobrar-baixar';

export function CobrarBaixarPage() {
  const [estado, setEstado] = useState<any>();
  const [tipo, setTipo] = useState('PAGAMENTO');
  const [valor, setValor] = useState('5.00');
  const [referencia, setReferencia] = useState('');
  const [autorizacao, setAutorizacao] = useState('');
  const [ocupado, setOcupado] = useState(false);

  async function chamar(caminho: string, corpo?: unknown) {
    setOcupado(true);
    try {
      const resposta = await chamarApi<any>(`${NS}${caminho}`, {
        metodo: caminho === '/state' ? 'GET' : 'POST',
        corpo,
      });
      setEstado(resposta.state);
    } finally {
      setOcupado(false);
    }
  }

  useEffect(() => {
    void chamar('/state');
  }, []);

  if (!estado) return <p role="status">Carregando cobranças…</p>;
  const titulo = estado.titulos[0];
  const decisaoSemTitulo = estado.decisoes.find(
    (decisao: any) => !estado.titulos.some((item: any) => item.decisao_id === decisao.id),
  );

  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <Landmark className="mr-2 inline" />
        {estado.titulo}
      </h1>
      <p>{estado.descricao}</p>
      {estado.alertas.map((alerta: any) => (
        <p role="alert" key={alerta.codigo}>
          {alerta.mensagem} <code>{alerta.codigo}</code>
        </p>
      ))}
      {decisaoSemTitulo && (
        <Button
          disabled={ocupado}
          onClick={() =>
            void chamar('/verbs/emitir_titulo', {
              decisaoId: decisaoSemTitulo.id,
              encargos: 0,
              chaveIdempotencia: crypto.randomUUID(),
            })
          }
        >
          Emitir título da decisão de R$ {decisaoSemTitulo.valor_final}
        </Button>
      )}
      {titulo && (
        <>
          <article className="rounded-md border p-4">
            <h2 className="text-xl font-semibold">{titulo.numero}</h2>
            <p>
              Principal R$ {titulo.principal} · Encargos R$ {titulo.encargos_iniciais}
            </p>
            <p className="text-lg font-semibold">
              Saldo R$ {Number(titulo.saldo).toFixed(2)} · {titulo.situacao}
            </p>
            <code className="break-all">Decisão {titulo.decisao_id}</code>
          </article>
          <section className="grid gap-3 rounded-md border p-4 sm:grid-cols-2">
            <label>
              Tipo
              <select
                className="block w-full rounded-md border bg-background p-2"
                value={tipo}
                onChange={(evento) => setTipo(evento.target.value)}
              >
                <option value="PAGAMENTO">Pagamento</option>
                <option value="ESTORNO">Estorno</option>
                <option value="CANCELAMENTO_JUDICIAL">Cancelamento judicial</option>
              </select>
            </label>
            <label>
              Valor
              <input
                className="block w-full rounded-md border bg-background p-2"
                inputMode="decimal"
                value={valor}
                onChange={(evento) => setValor(evento.target.value)}
              />
            </label>
            <label>
              Referência bancária
              <input
                className="block w-full rounded-md border bg-background p-2"
                value={referencia}
                onChange={(evento) => setReferencia(evento.target.value)}
              />
            </label>
            <label>
              Autorização
              <input
                className="block w-full rounded-md border bg-background p-2"
                value={autorizacao}
                onChange={(evento) => setAutorizacao(evento.target.value)}
              />
            </label>
            <Button
              disabled={ocupado || !referencia || !autorizacao || Number(valor) <= 0}
              onClick={() =>
                void chamar('/verbs/registrar_movimento', {
                  tituloId: titulo.id,
                  tipo,
                  valor: Number(valor),
                  referencia,
                  autorizacao,
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Registrar movimento
            </Button>
          </section>
          <section className="space-y-2">
            <h2 className="text-xl font-semibold">Movimentos imutáveis</h2>
            {titulo.movimentos.map((movimento: any) => (
              <article className="rounded-md border p-3" key={movimento.id}>
                <p>
                  <strong>{movimento.tipo}</strong> · R$ {movimento.valor} ·{' '}
                  {movimento.referencia_bancaria ?? 'sem referência bancária'}
                </p>
                <p>{movimento.autorizacao}</p>
                <code className="break-all">{movimento.id}</code>
                {movimento.tipo === 'PAGAMENTO' && !movimento.conciliacao_id && (
                  <Button
                    className="mt-2"
                    disabled={ocupado}
                    onClick={() =>
                      void chamar('/verbs/conciliar_pagamento', {
                        movimentoId: movimento.id,
                        referenciaBancaria: movimento.referencia_bancaria,
                        chaveIdempotencia: crypto.randomUUID(),
                      })
                    }
                  >
                    Conciliar pagamento
                  </Button>
                )}
                {movimento.conciliacao_id && <p>Conciliado: {movimento.conciliado_referencia}</p>}
              </article>
            ))}
          </section>
        </>
      )}
      {estado.resultado && (
        <p role="status">Operação persistida: {JSON.stringify(estado.resultado)}</p>
      )}
    </main>
  );
}
